// Mirror of sopkoa/helpers/statusHelper.js. A signed record that is unlocked moves to `unlocked`
// rather than back to `inprogress`; for edit/sign/delete gates both mean "open", so gates use
// isOpenStatus() instead of comparing against inprogress.
//
// `key` is the constants group: 'statuses' (default), 'productionOrderStatuses',
// 'productionBatchStatuses', 'purchaseOrderStatuses', 'documentStatuses', 'documentReviewStatuses'.
// Until a tenant's constants carry `unlocked` these behave exactly like the inprogress checks.

const group = (constants, key = 'statuses') => constants?.[key] ?? {};

export const openStatuses = (constants, key) => {
  const g = group(constants, key);
  return [g.inprogress, g.unlocked].filter(x => x != null);
};

export const isOpenStatus = (status, constants, key) =>
  status != null && status !== '' && openStatuses(constants, key).includes(status?._id ?? status);

export const isUnlockedStatus = (status, constants, key) => {
  const unlocked = group(constants, key).unlocked;
  return unlocked != null && (status?._id ?? status) === unlocked;
};
